import CancerType from './cancerTypes';

export const NEW_CANCER_TYPES = [CancerType.RCC, CancerType.MESO, CancerType.GENERAL, CancerType.CML];
